import { formatUrlId, parseUrlId } from '@cargoflow/validators'
import { createFileRoute } from '@tanstack/react-router'
import { RoutesDetailPage } from '@/features/routes/routes-detail-page'

export const Route = createFileRoute('/_authenticated/routes/$route_id/')({
  params: {
    parse: ({ route_id }) => ({ route_id: parseUrlId(route_id) }),
    stringify: ({ route_id }) => ({ route_id: formatUrlId('RT', route_id) }),
  },
  component: RoutesDetailPage,
})
